import axios from 'axios'
import config from '../../config'

let ReportingApi = {
  postReport(model) {
    return axios.post(config.apiUrl + 'report', model);
  },
  getReasons() {
    return axios.get(config.apiUrl + 'list/reporting-reasons')
  },
  removeReports(type, type_id) {
    return axios.delete(config.apiUrl + 'reports', {
      params: {
        type: type,
        type_id: type_id
      }
    })
  },
  getLifeReports(comment_id, type) {
    return axios.get(config.apiUrl + `report/life/${comment_id}`, {
      params: {
        type: type,
      }
    })
  },
  getQuestionReport(questionId) {
    return axios.get(config.apiUrl + 'report/question/' + questionId)
  },
  getAnswerReport(answerId) {
    return axios.get(config.apiUrl + 'report/answer/' + answerId)
  },
  getReport(type, type_id) {
    return axios.get(config.apiUrl + 'report/', {
        params: {
          type: type,
          type_id: type_id
        }
      }
    )
  },
  getReports(params) {
    return axios.get(config.apiUrl + 'reports', {
      params: {
        page: params.page,
        per_page: params.per_page,
      }
    });
  }
};

export default ReportingApi;



// WEBPACK FOOTER //
// ./src/api/Reporting/index.js